import type {ReactElement} from 'react';
import React, {useRef, useState} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItem7} from '@Components/controlled-list/controlled-list.types';
import styles from './page-background-flyout-option.module.scss';

interface PageBackgroundFlyoutOptionProps {
  id: string;
  text: string;
  icon: string;
  items: ControlledListItem7[];
}

export function PageBackgroundFlyoutOption({id, text, icon, items}: PageBackgroundFlyoutOptionProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onMouseEnter = (): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout((): void => {
      setIsOpen(true);
    }, 300);
  };

  const onMouseLeave = (): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout((): void => {
      setIsOpen(false);
    }, 300);
  };

  return (
    <Dropdown
      open={isOpen}
      stopClickPropagation
      doCloseOnInnerClick={false}
      position={DROPDOWN_POSITION.FIXED}
      alignment={ALIGNMENT_TYPE.LEFT_START}
      selector={
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          <ControlledListItemType7
            rightIconClassName={styles.rightIconColor}
            rightIcon="icon-caret-right"
            className="spacing-m-b-2"
            id={id}
            text={text}
            icon={icon}
          />
        </div>
      }
      popup={
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          <ControlledList className="spacing-m-0" items={items} />
        </div>
      }
    />
  );
}
